import React from 'react';
import PropTypes from 'prop-types';

// DataObjects.
import { ActionDataObject } from '@exonet/jsonapi-data-collections';

// Styled.
import * as S from './styled';

const ActionDate = ({ action }) => (
  <S.Status action={action}>
    <span>{action.getDate().asDateTime()}</span>
  </S.Status>
);

ActionDate.propTypes = {
  action: PropTypes.instanceOf(ActionDataObject).isRequired,
};

export default ActionDate;
